import { render, staticRenderFns } from "./DrawerCustomiseCover.vue?vue&type=template&id=485cedc5&scoped=true&"
import script from "./DrawerCustomiseCover.vue?vue&type=script&lang=js&"
export * from "./DrawerCustomiseCover.vue?vue&type=script&lang=js&"
import style0 from "./DrawerCustomiseCover.vue?vue&type=style&index=0&id=485cedc5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485cedc5",
  null
  
)

export default component.exports